<template>
  <div class="combn_cup">
    <img src="../../../../static/img/common/memberBn.jpg" width="100%" alt="">
  </div>
</template>
<script>
import { homeCommonData } from '@/api/frontApi/frontHome';
export default {
  data() {
    return {
      srcArr: [
        { path: '../../../../static/img/productModule/p_1.jpg', index: 1 },
        { path: '../../../../static/img/productModule/p_2.jpg', index: 2 }
      ],
      bannerHight: 500,
      memberBannerList: []
    };
  },
  components: {},
  created() {
    this.getMemeberBanner();
  },
  methods: {
    getMemeberBanner() {
      homeCommonData({ pageNo: 1, pageSize: 100, commonType: 1 }).then(res => {
        let tempBnnerArr = res.data.records;
        for (let i = 0; i < tempBnnerArr.length; i++) {
          let banObj = { path: '', title: '' };
          if (tempBnnerArr[i].commonImg) {
            banObj.path = tempBnnerArr[i].commonImg;
            banObj.title = tempBnnerArr[i].commonId;
            this.memberBannerList.push(banObj);
          } else {
            continue;
          }
        }
      });
    }
  }
};
</script>
<style scoped>
.combn_cup {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/members/memberBanner.vue